import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'bloko/blocks/input/input.less';

const Input = React.forwardRef((props, ref) => {
    const { scale, size, capitalize, centered, invalid, xsOnlyPlaceholder, ...inputProps } = props;
    return (
        <input
            {...inputProps}
            ref={ref}
            className={classnames('bloko-input', {
                [`bloko-input_${scale}`]: scale,
                'bloko-input_sized': size,
                'bloko-input_name': capitalize,
                'bloko-input_centered': centered,
                'bloko-input_invalid': invalid,
                'bloko-input_xs-only-placeholder': xsOnlyPlaceholder,
            })}
            size={size}
        />
    );
});

Input.types = {
    text: 'text',
    password: 'password',
    number: 'number',
    search: 'search',
    date: 'date',
    time: 'time',
    month: 'month',
    email: 'email',
    tel: 'tel',
    url: 'url',
};

// Ширина контрола задается стилями через атрибут size. Предусмотрены значения от 2 до 40.
const sizeVariants = [];
for (let i = 2; i <= 40; i++) {
    sizeVariants.push(String(i));
}

Input.propTypes = {
    /** Тип контрола. Возможные варианты [Input.types](#input-types) */
    type: PropTypes.oneOf(Object.keys(Input.types).map((id) => Input.types[id])).isRequired,
    /** Значение контрола по умолчанию для uncontrolled поля */
    defaultValue: PropTypes.string,
    /** Значение контрола */
    value: PropTypes.string,
    /** Значение placeholder контрола */
    placeholder: PropTypes.string,
    /** Размеры контрола */
    scale: PropTypes.oneOf(['small', 'large']),
    /** Ширина контрола. Допустимые значения от "2" до "40" */
    size: PropTypes.oneOf(sizeVariants),
    /** Флаг капитализации текста */
    capitalize: PropTypes.bool,
    /** Флаг выравнивания текста по центру */
    centered: PropTypes.bool,
    /** Флаг недоступности контрола */
    disabled: PropTypes.bool,
    /** Флаг невалидности контрола */
    invalid: PropTypes.bool,
    /** Показывать placeholder только на xs */
    xsOnlyPlaceholder: PropTypes.bool,
    /** Обработчик onChange, в качестве аргумента передает объект event */
    onChange: PropTypes.func,
};

Input.defaultProps = {
    type: Input.types.text,
    capitalize: false,
    centered: false,
    disabled: false,
    invalid: false,
    xsOnlyPlaceholder: false,
};

export default Input;
